var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('owner-form',{attrs:{"owner":_vm.owner,"status":_vm.formState},on:{"update:status":function($event){_vm.formState=$event},"reset":_vm.clearOwner,"input:owner-key":_vm.fetchOwnerByKey,"submit:owner":_vm.submitOwner}})}
var staticRenderFns = []

export { render, staticRenderFns }